import styled from "styled-components";

import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const ChartWrapper = styled.div`
    flex: 1;
`;

export const TotalSingleWrapper = styled(FlexRow)`
    margin: 0 0 10px 24px;
`;

export const LegendsContainer = styled(FlexColumn)`
    box-sizing: border-box;
    padding: 0 24px;
    gap: 16px;
`;
